// extracted by mini-css-extract-plugin
export default {"MONTH":"M13sog","month":"M13sog","DAY":"tz7YmM","day":"tz7YmM","YEAR":"UByuyK","year":"UByuyK","fields":"QYc_kj","mobile":"I20t4Z"};